import Head from "next/head";
import Link from "next/link";

const GoneNotice = () => (
  <>
    <Head>
      <title>Listing removed | TurfBooking.in</title>
      <meta name="robots" content="noindex, nofollow" />
    </Head>
    <main style={{ maxWidth: 640, margin: "4rem auto", padding: "0 1.5rem" }}>
      <h1>This listing is no longer available</h1>
      <p>
        The turf or court at this address has been removed or hidden, so it is
        not shown on TurfBooking.in anymore.
      </p>
      <p>
        <Link href="/">Browse turfs</Link>
      </p>
    </main>
  </>
);

export default GoneNotice;
